import { TableColumnMeta } from "ds/components/Table/types";

export const VCS_AGENT_POOLS_TABLE_STORAGE_KEY = "vcsAgentPoolsTableStorageKey";
export const VCS_AGENT_POOLS_TABLE_FILTERS_STORAGE_KEY = "vcsAgentPoolsTableFiltersStorageKey";

export enum VCS_AGENT_POOLS_COLUMN_ID {
  NAME = "NAME",
  DESCRIPTION = "DESCRIPTION",
  AGENT_CONNECTIONS = "AGENT_CONNECTIONS",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 1200;

export const VCS_AGENT_POOLS_TABLE_COLUMNS_CONFIG: Record<
  VCS_AGENT_POOLS_COLUMN_ID,
  TableColumnMeta
> = {
  [VCS_AGENT_POOLS_COLUMN_ID.NAME]: {
    id: VCS_AGENT_POOLS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    configurable: true,
  },
  [VCS_AGENT_POOLS_COLUMN_ID.DESCRIPTION]: {
    id: VCS_AGENT_POOLS_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 112,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [VCS_AGENT_POOLS_COLUMN_ID.AGENT_CONNECTIONS]: {
    id: VCS_AGENT_POOLS_COLUMN_ID.AGENT_CONNECTIONS,
    title: "Connections",
    minWidth: 100,
    defaultWidth: 100,
    maxWidth: 100,
    resizable: false,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [VCS_AGENT_POOLS_COLUMN_ID.DROPDOWN]: {
    id: VCS_AGENT_POOLS_COLUMN_ID.DROPDOWN,
    title: "VCS agent pool actions",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
  },
};

export const SORT_CONFIG: Record<VCS_AGENT_POOLS_COLUMN_ID, string> = {
  [VCS_AGENT_POOLS_COLUMN_ID.NAME]: "name",
  [VCS_AGENT_POOLS_COLUMN_ID.DESCRIPTION]: "description",
  [VCS_AGENT_POOLS_COLUMN_ID.AGENT_CONNECTIONS]: "connections",
  [VCS_AGENT_POOLS_COLUMN_ID.DROPDOWN]: "dropdown",
};
